export const SECTION_ID_TAG = "section_"
export const TOP_OFFSET = 60
